module.exports = __webpack_public_path__ + "static/media/logo.6f70551c.png";